module.exports = __webpack_public_path__ + "static/img/exercise-4.22cf068.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/exercise-4.png
// module id = VYdM
// module chunks = 1